import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTicketsFlow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={509}
    height={99}
    fill="none"
    {...props}
  >
    <path
      fill="#9798AE"
      d="M6.07 88.145a1.26 1.26 0 0 0-.544-.942q-.476-.337-1.237-.337-.536 0-.919.161a1.36 1.36 0 0 0-.586.439 1.07 1.07 0 0 0-.208.632q0 .296.134.513.138.217.374.37.235.147.521.248t.578.171l.886.222q.535.124 1.03.337.498.212.89.535.397.324.628.78.231.457.231 1.072 0 .83-.425 1.463-.424.628-1.228.983-.798.351-1.934.351-1.104 0-1.916-.341-.807-.341-1.265-.998-.451-.656-.49-1.597h1.686q.037.494.305.822.267.327.697.49.433.16.97.16.558 0 .978-.166.425-.17.665-.47.24-.305.244-.711a.9.9 0 0 0-.217-.61 1.6 1.6 0 0 0-.595-.406 6 6 0 0 0-.887-.295l-1.075-.277q-1.168-.3-1.847-.91-.674-.614-.674-1.63 0-.834.453-1.463a3 3 0 0 1 1.241-.974q.786-.35 1.778-.35 1.006 0 1.763.35.762.346 1.196.965.435.614.448 1.412zm6.324 6.993q-1.039 0-1.8-.457a3.1 3.1 0 0 1-1.182-1.278q-.416-.822-.416-1.92 0-1.1.416-1.926.42-.825 1.182-1.283t1.8-.457q1.04 0 1.8.457.762.457 1.178 1.283.42.827.42 1.925 0 1.1-.42 1.92-.416.823-1.178 1.28-.76.456-1.8.456m.01-1.338q.563 0 .941-.31.378-.314.563-.84.19-.526.19-1.172a3.5 3.5 0 0 0-.19-1.178 1.86 1.86 0 0 0-.563-.844q-.378-.315-.942-.314-.577 0-.96.314-.378.313-.568.844a3.5 3.5 0 0 0-.184 1.178q0 .645.184 1.172.19.526.568.84.383.31.96.31m9.326-1.782v-4.109h1.67V95h-1.62v-1.26h-.073q-.24.595-.79.974-.544.378-1.343.378a2.4 2.4 0 0 1-1.233-.309 2.15 2.15 0 0 1-.83-.91q-.3-.6-.3-1.449v-4.515h1.67v4.256q0 .675.37 1.072t.97.397q.368 0 .715-.18.346-.181.568-.536.225-.36.226-.9M25.12 95v-7.09h1.62v1.18h.074q.193-.613.664-.946a1.83 1.83 0 0 1 1.085-.337q.14 0 .31.014.175.01.29.033v1.537a1.8 1.8 0 0 0-.337-.065 3 3 0 0 0-.438-.032q-.457 0-.822.199-.36.193-.568.54-.207.346-.207.798V95zm7.955.138q-1.062 0-1.824-.466a3.1 3.1 0 0 1-1.168-1.288q-.405-.826-.406-1.902 0-1.08.416-1.906a3.1 3.1 0 0 1 1.172-1.293q.762-.466 1.8-.466.864 0 1.529.318.669.315 1.066.891.398.573.452 1.34h-1.597a1.53 1.53 0 0 0-.462-.855q-.36-.346-.964-.346-.513 0-.9.277-.389.272-.605.785-.213.511-.213 1.227 0 .726.213 1.247.212.517.595.799.388.276.91.277.369 0 .66-.139.295-.143.494-.41.198-.269.272-.652h1.597q-.06.753-.443 1.335a2.6 2.6 0 0 1-1.043.904q-.66.324-1.551.323m7.549 0q-1.067 0-1.842-.443a3 3 0 0 1-1.187-1.265q-.415-.82-.415-1.934 0-1.095.415-1.92.42-.831 1.173-1.293.753-.466 1.768-.466.656 0 1.237.212.587.208 1.034.646.453.439.711 1.118.26.673.259 1.606v.513h-5.812v-1.127h4.21a1.8 1.8 0 0 0-.208-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.84-.217q-.512 0-.9.249-.387.244-.605.646a1.86 1.86 0 0 0-.217.873v.983q0 .618.226 1.062.227.438.633.674.406.23.95.23.366 0 .661-.1.296-.108.512-.31.217-.203.328-.503l1.56.175a2.43 2.43 0 0 1-.563 1.08 2.75 2.75 0 0 1-1.052.711q-.642.25-1.468.25m10.171-5.355-1.523.167a1.2 1.2 0 0 0-.227-.434 1.1 1.1 0 0 0-.424-.328 1.55 1.55 0 0 0-.656-.125q-.522 0-.877.226-.352.227-.346.587a.61.61 0 0 0 .226.503q.235.194.776.318l1.21.259q1.006.217 1.495.688.494.471.498 1.232-.004.67-.392 1.182-.382.508-1.066.794t-1.57.286q-1.302 0-2.096-.544-.795-.55-.946-1.528l1.63-.157q.11.48.47.724.36.245.937.245.596 0 .956-.245.365-.244.365-.604a.63.63 0 0 0-.236-.503q-.231-.199-.72-.305l-1.21-.254q-1.02-.212-1.509-.716-.49-.507-.485-1.283a1.82 1.82 0 0 1 .356-1.136q.365-.484 1.01-.747.652-.268 1.501-.268 1.247 0 1.962.53.72.532.891 1.436M278.933 85.546h2.095l2.807 6.85h.111l2.807-6.85h2.096V95h-1.644v-6.495h-.087l-2.613 6.467h-1.228l-2.613-6.481h-.088V95h-1.643zm14.846 9.592q-1.067 0-1.842-.443a3 3 0 0 1-1.186-1.265q-.416-.82-.416-1.934 0-1.095.416-1.92.42-.831 1.172-1.293.753-.466 1.768-.466.656 0 1.238.212.585.208 1.034.646.452.439.711 1.118.258.673.258 1.606v.513h-5.812v-1.127h4.21a1.8 1.8 0 0 0-.207-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.841-.217 1.63 1.63 0 0 0-.9.249q-.387.244-.604.646a1.85 1.85 0 0 0-.217.873v.983q0 .618.226 1.062.226.438.632.674.406.23.951.23.365 0 .66-.1a1.5 1.5 0 0 0 .513-.31q.216-.203.328-.503l1.56.175a2.44 2.44 0 0 1-.563 1.08 2.75 2.75 0 0 1-1.053.711q-.642.25-1.468.25m4.567-.138v-7.09h1.62v1.18h.074q.194-.613.665-.946a1.83 1.83 0 0 1 1.085-.337q.138 0 .309.014.175.01.291.033v1.537a1.8 1.8 0 0 0-.337-.065 3 3 0 0 0-.439-.032 1.7 1.7 0 0 0-.821.199q-.36.193-.568.54-.208.346-.208.798V95zm7.946 2.807q-.9 0-1.546-.245-.647-.24-1.039-.646a2.24 2.24 0 0 1-.545-.9l1.505-.365q.102.207.296.41.194.21.521.342.333.14.836.139.71 0 1.177-.346.466-.342.466-1.127v-1.343h-.083q-.129.259-.378.53-.245.273-.651.458-.402.184-1.011.184a2.9 2.9 0 0 1-1.482-.383q-.66-.387-1.053-1.154-.387-.77-.388-1.93 0-1.167.388-1.97.393-.81 1.057-1.224a2.7 2.7 0 0 1 1.482-.42q.623 0 1.025.212.406.208.646.503.24.29.365.55h.092v-1.173h1.649v7.206q0 .91-.434 1.505-.434.596-1.187.891-.752.296-1.708.296m.014-4.22q.53 0 .905-.258a1.6 1.6 0 0 0 .568-.743q.193-.485.193-1.164 0-.67-.193-1.172a1.68 1.68 0 0 0-.564-.78q-.369-.282-.909-.282-.558 0-.933.29-.374.291-.563.8a3.2 3.2 0 0 0-.189 1.144q0 .651.189 1.14.194.485.568.758.378.267.928.267m8.166 1.551q-1.065 0-1.841-.443a3 3 0 0 1-1.187-1.265q-.415-.82-.415-1.934 0-1.095.415-1.92a3.14 3.14 0 0 1 1.173-1.293q.752-.466 1.768-.466.655 0 1.237.212a2.8 2.8 0 0 1 1.034.646q.453.439.711 1.118.259.673.259 1.606v.513h-5.813v-1.127h4.211a1.8 1.8 0 0 0-.208-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.84-.217q-.513 0-.9.249-.388.244-.605.646a1.85 1.85 0 0 0-.217.873v.983q0 .618.226 1.062.227.438.633.674.405.23.951.23.365 0 .66-.1.295-.108.512-.31.217-.203.328-.503l1.56.175a2.4 2.4 0 0 1-.563 1.08 2.75 2.75 0 0 1-1.052.711q-.642.25-1.469.25m7.199-.013a2.7 2.7 0 0 1-1.496-.43q-.66-.429-1.043-1.246-.384-.818-.384-1.985 0-1.182.388-1.995.393-.816 1.057-1.232a2.7 2.7 0 0 1 1.482-.42q.623 0 1.025.212.402.208.637.503.236.29.365.55h.069v-3.536h1.676V95h-1.643v-1.117h-.102a3 3 0 0 1-.374.55q-.245.285-.646.488-.402.204-1.011.204m.466-1.371q.531 0 .905-.287.373-.29.568-.808a3.4 3.4 0 0 0 .194-1.205q0-.687-.194-1.195a1.7 1.7 0 0 0-.564-.79q-.369-.28-.909-.281-.558 0-.933.29a1.76 1.76 0 0 0-.563.804 3.4 3.4 0 0 0-.189 1.172q0 .666.189 1.187.195.517.568.817.379.296.928.296M330.526 95v-9.454h6.149v1.435h-4.436v2.567h4.118v1.436h-4.118v2.58h4.473V95zm9.494-4.155V95h-1.671v-7.09h1.597v1.204h.083q.245-.596.78-.946.54-.351 1.335-.351.733 0 1.278.314.55.313.85.91.305.594.3 1.444V95h-1.671v-4.256q0-.711-.37-1.113-.364-.402-1.011-.402-.438 0-.78.194-.336.19-.531.55-.189.36-.189.872m9.792-2.936v1.293h-4.077v-1.293zm-3.07-1.699h1.671v6.657q0 .337.101.517a.55.55 0 0 0 .277.24q.17.065.379.065.157 0 .286-.023.134-.024.203-.042l.282 1.307q-.134.045-.383.101a3 3 0 0 1-.6.065 2.7 2.7 0 0 1-1.131-.19 1.76 1.76 0 0 1-.799-.655q-.29-.443-.286-1.108zm4.467 8.79v-7.09h1.671V95zm.84-8.097a.98.98 0 0 1-.683-.263.85.85 0 0 1-.286-.642q0-.378.286-.642a.97.97 0 0 1 .683-.268q.402 0 .684.268.286.264.286.642 0 .374-.286.642a.97.97 0 0 1-.684.263m6.091 1.006v1.293h-4.077v-1.293zm-3.07-1.699h1.671v6.657q0 .337.102.517.106.175.276.24t.379.065q.157 0 .286-.023.134-.024.203-.042l.282 1.307q-.134.045-.383.101a3 3 0 0 1-.6.065 2.7 2.7 0 0 1-1.131-.19 1.76 1.76 0 0 1-.799-.655q-.29-.443-.286-1.108zm4.467 8.79v-7.09h1.672V95zm.841-8.097a.98.98 0 0 1-.684-.263.85.85 0 0 1-.286-.642q0-.378.286-.642a.97.97 0 0 1 .684-.268q.4 0 .683.268.286.264.286.642 0 .374-.286.642a.97.97 0 0 1-.683.263m5.688 8.235q-1.067 0-1.842-.443a3 3 0 0 1-1.186-1.265q-.416-.82-.416-1.934 0-1.095.416-1.92.42-.831 1.172-1.293.752-.466 1.769-.466.655 0 1.237.212.586.208 1.034.646.452.439.711 1.118.258.673.258 1.606v.513h-5.812v-1.127h4.21a1.8 1.8 0 0 0-.207-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.84-.217 1.63 1.63 0 0 0-.901.249q-.388.244-.604.646a1.85 1.85 0 0 0-.217.873v.983q0 .618.226 1.062.226.438.632.674.406.23.951.23.365 0 .66-.1a1.5 1.5 0 0 0 .513-.31q.217-.203.328-.503l1.56.175a2.4 2.4 0 0 1-.563 1.08 2.75 2.75 0 0 1-1.053.711q-.642.25-1.468.25m10.171-5.355-1.523.167a1.2 1.2 0 0 0-.226-.434 1.1 1.1 0 0 0-.425-.328 1.55 1.55 0 0 0-.655-.125q-.522 0-.878.226-.35.227-.346.587a.62.62 0 0 0 .226.503q.236.194.776.318l1.21.259q1.005.217 1.495.688.495.471.499 1.232-.005.67-.393 1.182-.382.508-1.066.794-.683.286-1.57.286-1.301 0-2.095-.544-.795-.55-.947-1.528l1.63-.157q.111.48.471.724.36.245.937.245.595 0 .955-.245.365-.244.365-.604a.63.63 0 0 0-.235-.503q-.231-.199-.72-.305l-1.21-.254q-1.02-.212-1.51-.716-.489-.507-.484-1.283a1.82 1.82 0 0 1 .355-1.136q.364-.484 1.011-.747.651-.268 1.5-.268 1.246 0 1.963.53.72.532.89 1.436M464.517 86.981v-1.435h7.543v1.435h-2.922V95h-1.699v-8.019zM473.441 95v-7.09h1.671V95zm.84-8.097a.97.97 0 0 1-.683-.263.85.85 0 0 1-.287-.642q0-.378.287-.642a.96.96 0 0 1 .683-.268q.401 0 .683.268.286.264.286.642 0 .374-.286.642a.96.96 0 0 1-.683.263m5.642 8.235q-1.06 0-1.823-.466a3.1 3.1 0 0 1-1.168-1.288q-.406-.826-.406-1.902 0-1.08.415-1.906a3.1 3.1 0 0 1 1.173-1.293q.762-.466 1.8-.466.864 0 1.528.318.67.315 1.067.891.396.573.452 1.34h-1.597a1.53 1.53 0 0 0-.462-.855q-.36-.346-.965-.346a1.5 1.5 0 0 0-.9.277q-.388.272-.605.785-.212.511-.212 1.227 0 .726.212 1.247.212.517.596.799.387.276.909.277.369 0 .66-.139.296-.143.494-.41a1.6 1.6 0 0 0 .273-.652h1.597a2.8 2.8 0 0 1-.443 1.335 2.63 2.63 0 0 1-1.043.904q-.661.324-1.552.323m5.934-2.363-.005-2.018h.268l2.548-2.848h1.953l-3.135 3.49h-.346zM484.333 95v-9.454h1.671V95zm4.451 0-2.309-3.227 1.127-1.177 3.18 4.404zm5.798.138q-1.067 0-1.842-.443a3 3 0 0 1-1.187-1.265q-.415-.82-.415-1.934 0-1.095.415-1.92a3.15 3.15 0 0 1 1.173-1.293q.753-.466 1.768-.466.656 0 1.237.212a2.8 2.8 0 0 1 1.034.646q.453.439.711 1.118.26.673.259 1.606v.513h-5.812v-1.127h4.21a1.8 1.8 0 0 0-.208-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.84-.217 1.63 1.63 0 0 0-.9.249q-.388.244-.605.646a1.87 1.87 0 0 0-.217.873v.983q0 .618.226 1.062.227.438.633.674.407.23.951.23.365 0 .66-.1a1.5 1.5 0 0 0 .513-.31q.216-.203.327-.503l1.561.175a2.44 2.44 0 0 1-.564 1.08 2.7 2.7 0 0 1-1.052.711q-.642.25-1.468.25m8.108-7.229v1.293h-4.077v-1.293zm-3.07-1.699h1.671v6.657q0 .337.101.517a.55.55 0 0 0 .277.24q.17.065.379.065.156 0 .286-.023.134-.024.203-.042l.282 1.307q-.134.045-.383.101a3 3 0 0 1-.601.065 2.7 2.7 0 0 1-1.131-.19 1.76 1.76 0 0 1-.798-.655q-.29-.443-.286-1.108zM144.933 95v-9.454h6.149v1.435h-4.437v2.567h4.118v1.436h-4.118v2.58h4.474V95zm9.493-4.155V95h-1.671v-7.09h1.597v1.204h.084q.244-.596.78-.946.54-.351 1.334-.351.733 0 1.279.314.549.313.849.91.305.594.3 1.444V95h-1.671v-4.256q0-.711-.369-1.113-.365-.402-1.011-.402-.44 0-.781.194-.336.19-.53.55-.19.36-.19.872m9.792-2.936v1.293h-4.076v-1.293zm-3.07-1.699h1.671v6.657q0 .337.102.517.106.175.277.24.17.065.378.065.157 0 .286-.023.134-.024.204-.042l.281 1.307q-.134.045-.383.101a3 3 0 0 1-.6.065 2.7 2.7 0 0 1-1.131-.19 1.76 1.76 0 0 1-.799-.655q-.29-.443-.286-1.108zm4.468 8.79v-7.09h1.671V95zm.84-8.097a.98.98 0 0 1-.684-.263.85.85 0 0 1-.286-.642q0-.378.286-.642a.97.97 0 0 1 .684-.268q.4 0 .683.268.286.264.286.642 0 .374-.286.642a.97.97 0 0 1-.683.263m6.09 1.006v1.293h-4.076v-1.293zm-3.07-1.699h1.671v6.657q0 .337.102.517a.55.55 0 0 0 .277.24q.171.065.378.065.157 0 .287-.023.133-.024.203-.042l.281 1.307q-.134.045-.383.101a3 3 0 0 1-.6.065 2.7 2.7 0 0 1-1.131-.19 1.76 1.76 0 0 1-.799-.655q-.29-.443-.286-1.108zm4.468 8.79v-7.09h1.671V95zm.84-8.097a.97.97 0 0 1-.683-.263.85.85 0 0 1-.287-.642q0-.378.287-.642a.96.96 0 0 1 .683-.268q.401 0 .683.268.286.264.286.642 0 .374-.286.642a.96.96 0 0 1-.683.263m5.688 8.235q-1.065 0-1.841-.443a3 3 0 0 1-1.187-1.265q-.415-.82-.415-1.934 0-1.095.415-1.92a3.14 3.14 0 0 1 1.173-1.293q.752-.466 1.768-.466.655 0 1.237.212a2.8 2.8 0 0 1 1.034.646q.453.439.711 1.118.258.673.259 1.606v.513h-5.813v-1.127h4.211a1.8 1.8 0 0 0-.208-.854 1.5 1.5 0 0 0-.568-.595 1.6 1.6 0 0 0-.84-.217q-.513 0-.9.249-.388.244-.605.646a1.85 1.85 0 0 0-.217.873v.983q0 .618.226 1.062.227.438.633.674.405.23.951.23.364 0 .66-.1.295-.108.512-.31.217-.203.328-.503l1.56.175a2.4 2.4 0 0 1-.563 1.08 2.75 2.75 0 0 1-1.052.711q-.642.25-1.469.25m10.172-5.355-1.524.167a1.2 1.2 0 0 0-.226-.434 1.1 1.1 0 0 0-.425-.328 1.55 1.55 0 0 0-.655-.125q-.522 0-.877.226-.351.227-.347.587a.61.61 0 0 0 .227.503q.235.194.775.318l1.21.259q1.006.217 1.495.688.495.471.499 1.232a1.93 1.93 0 0 1-.392 1.182q-.383.508-1.067.794t-1.569.286q-1.302 0-2.096-.544-.795-.55-.947-1.528l1.63-.157q.111.48.471.724.36.245.937.245.596 0 .956-.245.364-.244.364-.604a.63.63 0 0 0-.235-.503q-.231-.199-.72-.305l-1.21-.254q-1.02-.212-1.509-.716-.49-.507-.485-1.283a1.82 1.82 0 0 1 .355-1.136q.366-.484 1.011-.747.65-.268 1.501-.268 1.246 0 1.962.53.72.532.891 1.436"
    />
    <rect width={84.192} height={20.76} x={363.842} fill="#4E4E6B" rx={6.92} />
    <path
      fill="#fff"
      d="M370.041 5.398h1.216l2.432 4.093h.102l2.432-4.093h1.216l-3.168 5.155v3.613h-1.062v-3.613zm10.376 8.905q-.891 0-1.563-.424a2.9 2.9 0 0 1-1.045-1.186q-.372-.762-.372-1.78 0-1.029.372-1.795.378-.765 1.045-1.19.672-.424 1.563-.424t1.558.424q.672.425 1.045 1.19.377.767.377 1.794 0 1.02-.377 1.781a2.85 2.85 0 0 1-1.045 1.186q-.668.424-1.558.424m0-.908q.677 0 1.113-.346.437-.348.646-.912t.21-1.225q0-.66-.21-1.229a2.06 2.06 0 0 0-.646-.92q-.436-.351-1.113-.351-.676 0-1.113.35-.437.352-.647.921t-.21 1.23q0 .659.21 1.224.21.564.647.912.437.346 1.113.346m8.666-1.918V7.59h1.011v6.576h-1.011v-1.113h-.068a2.16 2.16 0 0 1-.719.852q-.489.347-1.234.347-.616 0-1.096-.27a1.9 1.9 0 0 1-.753-.822q-.274-.552-.274-1.392V7.59h1.01v4.11q0 .72.403 1.147.406.428 1.036.428.376 0 .766-.192a1.67 1.67 0 0 0 .66-.591q.269-.398.269-1.015m8.187 2.843a2.7 2.7 0 0 1-1.134-.235 1.94 1.94 0 0 1-.809-.69q-.3-.453-.3-1.096 0-.564.223-.916.222-.355.595-.556a3.1 3.1 0 0 1 .822-.3q.453-.103.912-.163.599-.077.971-.115.378-.043.548-.142.176-.098.176-.342V9.73q0-.634-.347-.985-.342-.351-1.04-.351-.724 0-1.135.317-.41.315-.578.676l-.959-.342q.258-.6.685-.934.434-.338.942-.47a4 4 0 0 1 1.011-.138q.316 0 .727.077.416.073.801.304.39.231.647.698.256.467.256 1.25v4.333h-1.01v-.89h-.051a1.8 1.8 0 0 1-.343.458q-.24.243-.638.415-.397.171-.972.171m.154-.908q.6 0 1.011-.235a1.6 1.6 0 0 0 .839-1.391v-.925q-.064.077-.283.141a5 5 0 0 1-.496.107 23 23 0 0 1-.968.129q-.393.051-.736.167a1.27 1.27 0 0 0-.548.338q-.206.222-.206.608 0 .525.39.796.394.265.997.265m4.705.754V7.59h.976v.993h.068q.18-.488.651-.792a1.9 1.9 0 0 1 1.062-.304q.111 0 .278.004.167.005.253.013v1.028a3 3 0 0 0-.236-.039 2.3 2.3 0 0 0-.381-.03q-.48 0-.856.201a1.474 1.474 0 0 0-.805 1.34v4.162zm7.042.137q-.95 0-1.639-.42a2.8 2.8 0 0 1-1.058-1.181q-.368-.763-.368-1.773t.368-1.78q.373-.776 1.036-1.208.668-.437 1.559-.437.513 0 1.014.171t.912.557q.411.38.655 1.01t.244 1.55v.428h-5.069v-.873h4.042q0-.557-.223-.993a1.68 1.68 0 0 0-.625-.69 1.75 1.75 0 0 0-.95-.252q-.604 0-1.045.3a2 2 0 0 0-.672.77 2.3 2.3 0 0 0-.236 1.02v.581q0 .746.257 1.263.261.514.724.784.462.265 1.074.265.399 0 .72-.11a1.5 1.5 0 0 0 .561-.344q.236-.231.363-.573l.977.274a2.2 2.2 0 0 1-.518.873 2.5 2.5 0 0 1-.899.582 3.3 3.3 0 0 1-1.204.206m8.662-4.093v3.956h-1.011V5.398h1.011v3.22h.085q.231-.51.694-.81.467-.303 1.241-.304.673 0 1.178.27.506.266.783.818.283.547.283 1.395v4.179h-1.011v-4.11q0-.783-.406-1.212-.403-.432-1.118-.432-.497 0-.89.21-.39.21-.617.612-.222.402-.222.976m8.87 4.093q-.951 0-1.64-.42a2.8 2.8 0 0 1-1.058-1.181q-.368-.763-.368-1.773t.368-1.78q.373-.776 1.036-1.208.669-.437 1.559-.437.514 0 1.015.171t.911.557q.411.38.655 1.01t.245 1.55v.428h-5.07v-.873h4.042q0-.557-.223-.993a1.68 1.68 0 0 0-.625-.69 1.75 1.75 0 0 0-.95-.252q-.604 0-1.045.3a2 2 0 0 0-.672.77 2.26 2.26 0 0 0-.235 1.02v.581q0 .746.256 1.263.262.514.724.784.462.265 1.075.265.398 0 .719-.11a1.5 1.5 0 0 0 .561-.344 1.6 1.6 0 0 0 .364-.573l.976.274a2.2 2.2 0 0 1-.518.873 2.5 2.5 0 0 1-.899.582 3.3 3.3 0 0 1-1.203.206m4.26-.137V7.59h.976v.993h.068q.18-.488.651-.792a1.9 1.9 0 0 1 1.062-.304q.111 0 .278.004.167.005.253.013v1.028a3 3 0 0 0-.236-.039 2.3 2.3 0 0 0-.381-.03q-.48 0-.856.201a1.474 1.474 0 0 0-.805 1.34v4.162zm7.042.137q-.95 0-1.639-.42a2.8 2.8 0 0 1-1.058-1.181q-.368-.763-.368-1.773t.368-1.78q.372-.776 1.036-1.208.668-.437 1.559-.437.513 0 1.014.171t.912.557q.411.38.655 1.01t.244 1.55v.428h-5.069v-.873h4.042q0-.557-.223-.993a1.68 1.68 0 0 0-.625-.69 1.75 1.75 0 0 0-.95-.252q-.604 0-1.045.3a2 2 0 0 0-.672.77 2.3 2.3 0 0 0-.236 1.02v.581q0 .746.257 1.263.261.514.724.784.462.265 1.074.265.399 0 .72-.11a1.5 1.5 0 0 0 .561-.344q.235-.231.363-.573l.977.274a2.2 2.2 0 0 1-.518.873 2.5 2.5 0 0 1-.9.582 3.3 3.3 0 0 1-1.203.206"
    />
    <path
      fill="#4E4E6B"
      d="M405.333 24.523a.846.846 0 0 0 1.412 0l2.605-3.947a.846.846 0 0 0-.707-1.312h-5.209a.846.846 0 0 0-.706 1.312z"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M407.955 43.867a.754.754 0 0 1-.114-1.06l2.823-3.505-2.823-3.506a.754.754 0 0 1 1.173-.945l3.586 4.45-3.586 4.451a.753.753 0 0 1-1.059.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M403.528 43.867a.754.754 0 0 1-.114-1.06l2.824-3.505-2.824-3.506a.754.754 0 1 1 1.174-.945l3.585 4.45-3.585 4.451a.754.754 0 0 1-1.06.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M399.103 43.867a.754.754 0 0 1-.114-1.06l2.824-3.505-2.824-3.506a.754.754 0 1 1 1.174-.945l3.585 4.45-3.585 4.451a.754.754 0 0 1-1.06.114M252.258 43.867a.753.753 0 0 1-.115-1.06l2.824-3.505-2.824-3.506a.753.753 0 1 1 1.174-.945l3.585 4.45-3.585 4.451a.753.753 0 0 1-1.059.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M247.831 43.867a.754.754 0 0 1-.114-1.06l2.823-3.505-2.823-3.506a.754.754 0 0 1 1.173-.945l3.586 4.45-3.586 4.451a.753.753 0 0 1-1.059.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M243.406 43.867a.754.754 0 0 1-.114-1.06l2.824-3.505-2.824-3.506a.754.754 0 1 1 1.174-.945l3.585 4.45-3.585 4.451a.754.754 0 0 1-1.06.114M89.64 43.867a.753.753 0 0 1-.114-1.06l2.824-3.505-2.824-3.506a.753.753 0 1 1 1.174-.945l3.585 4.45-3.585 4.451a.754.754 0 0 1-1.06.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M85.214 43.867a.753.753 0 0 1-.114-1.06l2.823-3.505-2.823-3.506a.753.753 0 1 1 1.173-.945l3.585 4.45-3.585 4.451a.754.754 0 0 1-1.06.114"
      clipRule="evenodd"
    />
    <path
      fill="#9798AE"
      fillRule="evenodd"
      d="M80.789 43.867a.753.753 0 0 1-.114-1.06l2.823-3.505-2.823-3.506a.753.753 0 1 1 1.173-.945l3.586 4.45-3.586 4.451a.754.754 0 0 1-1.06.114"
      clipRule="evenodd"
    />
    <circle
      cx={25.92}
      cy={17.186}
      r={6.273}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__a)"
      strokeWidth={1.294}
    />
    <circle
      cx={25.92}
      cy={62.164}
      r={6.273}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__b)"
      strokeWidth={1.294}
    />
    <circle
      cx={25.92}
      cy={39.674}
      r={6.273}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__c)"
      strokeWidth={1.294}
    />
    <rect
      width={47.722}
      height={14.177}
      x={303.94}
      y={10.336}
      fill="#fff"
      stroke="#C5C6D6"
      strokeWidth={1.294}
      rx={3.234}
    />
    <rect
      width={47.722}
      height={14.177}
      x={303.94}
      y={32.299}
      fill="#fff"
      stroke="#C5C6D6"
      strokeWidth={1.294}
      rx={3.234}
    />
    <rect
      width={47.722}
      height={14.177}
      x={303.94}
      y={54.262}
      fill="#fff"
      stroke="#C5C6D6"
      strokeWidth={1.294}
      rx={3.234}
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__d)"
      rx={1.266}
      transform="matrix(1 0 0 -1 324.63 42.555)"
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__e)"
      rx={1.266}
      transform="matrix(1 0 0 -1 309.059 42.555)"
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__f)"
      rx={1.266}
      transform="matrix(1 0 0 -1 340.199 42.555)"
    />
    <path
      fill="url(#ticketsFlow_svg__g)"
      d="M310.477 15.72c.779-1.35 1.169-2.026 1.754-2.026s.975.676 1.754 2.026l.986 1.708c.78 1.35 1.17 2.026.877 2.532s-1.072.506-2.631.506h-1.972c-1.559 0-2.339 0-2.632-.506-.292-.506.098-1.181.878-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__h)"
      d="M326.046 15.72c.78-1.35 1.17-2.026 1.754-2.026s.975.676 1.755 2.026l.986 1.708c.779 1.35 1.169 2.026.877 2.532s-1.072.506-2.632.506h-1.972c-1.559 0-2.339 0-2.631-.506-.293-.506.097-1.181.877-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__i)"
      d="m313.585 58.128-.001.001h-2.582a.94.94 0 0 0-.815.47l-1.29 2.229a.94.94 0 0 0 0 .941l1.29 2.232c.169.29.479.47.815.47h2.583a.94.94 0 0 0 .815-.47l1.289-2.232a.94.94 0 0 0 0-.941l-1.289-2.231a.94.94 0 0 0-.814-.47z"
    />
    <path
      fill="url(#ticketsFlow_svg__j)"
      d="m344.725 58.128-.001.001h-2.584a.94.94 0 0 0-.815.47l-1.287 2.229a.94.94 0 0 0 0 .941l1.289 2.232c.169.29.479.47.815.47h2.583a.94.94 0 0 0 .815-.47l1.29-2.232a.94.94 0 0 0 0-.941l-1.29-2.231a.94.94 0 0 0-.815-.469"
    />
    <rect
      width={47.722}
      height={58.102}
      x={460.213}
      y={10.334}
      fill="#fff"
      stroke="#C5C6D6"
      strokeWidth={1.294}
      rx={3.234}
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__k)"
      rx={1.266}
      transform="matrix(1 0 0 -1 480.904 42.553)"
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__l)"
      rx={1.266}
      transform="matrix(1 0 0 -1 465.333 42.553)"
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__m)"
      rx={1.266}
      transform="matrix(1 0 0 -1 496.474 42.553)"
    />
    <path
      fill="url(#ticketsFlow_svg__n)"
      d="M466.751 15.718c.78-1.35 1.17-2.025 1.754-2.025s.975.675 1.755 2.025l.986 1.708c.779 1.35 1.169 2.026.877 2.532s-1.072.507-2.632.507h-1.972c-1.559 0-2.339 0-2.631-.507-.292-.506.097-1.181.877-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__o)"
      d="M482.32 15.718c.78-1.35 1.17-2.025 1.755-2.025.584 0 .974.675 1.754 2.025l.986 1.708c.78 1.35 1.17 2.026.877 2.532s-1.072.507-2.631.507h-1.972c-1.56 0-2.339 0-2.632-.507-.292-.506.098-1.181.877-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__p)"
      d="m469.859 58.126-.001.001h-2.582a.94.94 0 0 0-.815.47l-1.289 2.229a.94.94 0 0 0 0 .941L466.461 64c.169.29.479.47.815.47h2.583a.94.94 0 0 0 .815-.47l1.289-2.232a.93.93 0 0 0 0-.941l-1.289-2.231a.94.94 0 0 0-.814-.47z"
    />
    <path
      fill="url(#ticketsFlow_svg__q)"
      d="m501 58.126-.001.001h-2.585a.94.94 0 0 0-.815.47l-1.287 2.229a.94.94 0 0 0 0 .941l1.29 2.232c.169.29.479.47.815.47H501a.94.94 0 0 0 .815-.47l1.289-2.232a.94.94 0 0 0 0-.941l-1.289-2.231a.94.94 0 0 0-.814-.47z"
    />
    <rect
      width={54.316}
      height={11.393}
      x={140.745}
      y={25.909}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__r)"
      strokeWidth={1.294}
      rx={2.802}
    />
    <rect
      width={54.316}
      height={11.393}
      x={140.745}
      y={10.338}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__s)"
      strokeWidth={1.294}
      rx={2.802}
    />
    <rect
      width={54.316}
      height={11.393}
      x={140.745}
      y={41.477}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__t)"
      strokeWidth={1.294}
      rx={2.802}
    />
    <rect
      width={54.316}
      height={11.393}
      x={140.745}
      y={57.049}
      fill="#fff"
      stroke="url(#ticketsFlow_svg__u)"
      strokeWidth={1.294}
      rx={2.802}
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__v)"
      rx={1.266}
      transform="matrix(1 0 0 -1 183.925 34.773)"
    />
    <rect
      width={6.343}
      height={6.343}
      fill="url(#ticketsFlow_svg__w)"
      rx={1.266}
      transform="matrix(1 0 0 -1 164.895 19.203)"
    />
    <path
      fill="url(#ticketsFlow_svg__x)"
      d="M146.758 14.457c.78-1.351 1.169-2.026 1.754-2.026s.975.675 1.754 2.026l.987 1.707c.779 1.35 1.169 2.026.877 2.532s-1.072.507-2.632.507h-1.972c-1.559 0-2.339 0-2.631-.507-.293-.506.097-1.181.877-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__y)"
      d="M174.673 45.597c.78-1.35 1.169-2.026 1.754-2.026s.975.676 1.755 2.026l.986 1.708c.779 1.35 1.169 2.026.877 2.532s-1.072.506-2.632.506h-1.972c-1.559 0-2.339 0-2.631-.506-.293-.506.097-1.182.877-2.532z"
    />
    <path
      fill="url(#ticketsFlow_svg__z)"
      d="M188.162 12.863h-2.583a.94.94 0 0 0-.815.47l-1.29 2.23a.94.94 0 0 0 0 .94l1.29 2.232c.169.291.479.47.815.47h2.583a.94.94 0 0 0 .815-.47l1.289-2.231a.94.94 0 0 0 0-.942l-1.289-2.231a.94.94 0 0 0-.814-.47z"
    />
    <path
      fill="url(#ticketsFlow_svg__A)"
      d="M150.519 59.572h-2.583a.94.94 0 0 0-.815.47l-1.289 2.23a.94.94 0 0 0 0 .94l1.289 2.232c.169.291.479.47.815.47h2.583a.94.94 0 0 0 .815-.47l1.29-2.231a.94.94 0 0 0 0-.942l-1.29-2.231a.94.94 0 0 0-.815-.468"
    />
    <defs>
      <linearGradient
        id="ticketsFlow_svg__a"
        x1={30.245}
        x2={12.945}
        y1={20.429}
        y2={20.069}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__b"
        x1={30.245}
        x2={12.945}
        y1={65.408}
        y2={65.047}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__c"
        x1={30.245}
        x2={12.945}
        y1={42.918}
        y2={42.557}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__d"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__e"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__f"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__g"
        x1={315.474}
        x2={302.5}
        y1={20.304}
        y2={20.034}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__h"
        x1={331.044}
        x2={318.069}
        y1={20.304}
        y2={20.034}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__i"
        x1={314.495}
        x2={305.689}
        y1={62.785}
        y2={62.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__j"
        x1={345.635}
        x2={336.83}
        y1={62.785}
        y2={62.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__k"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__l"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__m"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__n"
        x1={471.749}
        x2={458.774}
        y1={20.302}
        y2={20.032}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__o"
        x1={487.318}
        x2={474.343}
        y1={20.302}
        y2={20.032}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__p"
        x1={470.769}
        x2={461.963}
        y1={62.783}
        y2={62.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__q"
        x1={501.91}
        x2={493.104}
        y1={62.783}
        y2={62.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__r"
        x1={185.28}
        x2={116.313}
        y1={34.578}
        y2={28.28}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__s"
        x1={185.28}
        x2={116.313}
        y1={19.008}
        y2={12.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__t"
        x1={185.28}
        x2={116.313}
        y1={50.147}
        y2={43.849}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__u"
        x1={185.28}
        x2={116.313}
        y1={65.719}
        y2={59.421}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__v"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__w"
        x1={5.154}
        x2={-2.775}
        y1={4.658}
        y2={4.493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__x"
        x1={151.756}
        x2={138.781}
        y1={19.041}
        y2={18.77}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__y"
        x1={179.671}
        x2={166.696}
        y1={50.181}
        y2={49.911}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53A8FF" />
        <stop offset={1} stopColor="#C4E1FF" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__z"
        x1={189.072}
        x2={180.266}
        y1={17.52}
        y2={17.316}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="ticketsFlow_svg__A"
        x1={151.429}
        x2={142.623}
        y1={64.229}
        y2={64.025}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgTicketsFlow;
